import { render, staticRenderFns } from "./UIElement.vue?vue&type=template&id=5ef15de3&"
import script from "./UIElement.vue?vue&type=script&lang=js&"
export * from "./UIElement.vue?vue&type=script&lang=js&"
import style0 from "./UIElement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports